import React, { useEffect, useState } from "react";
import Service, { BedData } from "./Service";
import Gallery from "./Gallery";



export default function ViewBox(props:{onClose:Function ,bedDetails:BedData}) {

    const [loaded,setLoaded]=useState<boolean>(false)
    


    useEffect(()=>
    {
        setLoaded(true)
        
       
    },[])

  

    return (

        <div className={loaded?"GardenMapViewBox visible":"GardenMapViewBox"} >
            <svg 
            onClick={(e)=>
            {
                props.onClose()
            }
            }
            style={{cursor:"pointer"}}
            className="closeButton" width="44px" height="44px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10.0303 8.96965C9.73741 8.67676 9.26253 8.67676 8.96964 8.96965C8.67675 9.26255 8.67675 9.73742 8.96964 10.0303L10.9393 12L8.96966 13.9697C8.67677 14.2625 8.67677 14.7374 8.96966 15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12 13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303 13.9696L13.0606 12L15.0303 10.0303C15.3232 9.73744 15.3232 9.26257 15.0303 8.96968C14.7374 8.67678 14.2625 8.67678 13.9696 8.96968L12 10.9393L10.0303 8.96965Z" fill="#6b748e"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z" fill="#6b748e"></path> </g></svg>

            <div className="GardenMapViewCanvas">
                

            <div className="GardenMapDescription">
                <h4>Bed {props.bedDetails.bedIdentifier}</h4>
                <div className="BedContentInfo" dangerouslySetInnerHTML={{__html: props.bedDetails.description}}></div>
            <div className="plantsList">
               {props.bedDetails.alivePlants.length>0? <h4>Plants in this bed ({props.bedDetails.alivePlants.length})</h4>:<h3>There are no plants in this bed</h3>}
                <div className="plantListView">
                    {props.bedDetails.alivePlants.map((item,index)=>
                    {
                        return (<a key={index} target="_blank" href={process.env.REACT_APP_BASE+"/viewplant?plantid="+item.id} className="plantLink">{item.name}</a>)
                    })}
    

                </div>



            </div>
            </div>
            <div className="GardenMapPhotos">
                
            {<Gallery images={props.bedDetails.images} />}


        <span>

        </span>
            </div>
            </div>


        </div>
    )
}